import { filter, OperatorFunction } from 'rxjs'

export type Newable<T> = new (...args: any[]) => T

export function filterIfInstanceOf<A, I extends A>(clazz: Newable<I>): OperatorFunction<A, I> {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  return filter<A>((obj: A): obj is I => obj instanceof clazz)
}
